import { getListSpacesQueryOptions } from '@cocoonspace/sdk-js/domains/spaces/spaces'
import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import { QueryClient, dehydrate } from '@tanstack/react-query'
import type { GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { SearchPage } from '~/domains/search/components/search-page'
import { select } from '~/domains/search/config/select-api-keys'

export default SearchPage

export const getStaticProps = async ({
	locale,
	params,
}: GetStaticPropsContext) => {
	const queryClient = new QueryClient()

	try {
		await queryClient.fetchQuery(
			getListSpacesQueryOptions({
				...params,
				select,
				offer: ['desk'],
			}),
		)

		return {
			props: {
				...(await serverSideTranslations(locale as string, [
					...defaultI18nNs,
					'space',
					'features',
				])),
				dehydratedState: dehydrate(queryClient),
			},
			revalidate: 24 * 60 * 60, // 24h
		}
	} catch (e) {
		return { notFound: true }
	}
}

export const getStaticPaths = async () => {
	return {
		paths: [{ params: { zone: 'paris' } }, { params: { zone: 'lyon' } }],
		fallback: false,
	}
}
